import * as React from "react";
import { DocumentTitle } from "components/common";
import { getEnterpriseGroupSyncPlugin } from "util/AuthenticationService";
import WizardPageHeader from "./WizardPageHeader";
import handleCreate from "../HandleCreate";
import BackendWizard from "../BackendWizard";
export const AUTH_BACKEND_META = {
  serviceType: "ldap",
  serviceTitle: "LDAP"
};
export const HELP = {
  // server config help
  systemUserDn: /* @__PURE__ */ React.createElement("span", null, "The username for the initial connection to the LDAP server, e.g. ", /* @__PURE__ */ React.createElement("code", null, "cn=admin,dc=example,dc=com"), ", this might be optional depending on your LDAP server."),
  systemUserPassword: "The password for the initial connection to the LDAP server.",
  // user sync help
  userSearchBase: /* @__PURE__ */ React.createElement("span", null, "The base tree to limit the LDAP search query to, e.g. ", /* @__PURE__ */ React.createElement("code", null, "cn=users,dc=example,dc=com"), "."),
  userSearchPattern: /* @__PURE__ */ React.createElement("span", null, "For example ", /* @__PURE__ */ React.createElement("code", { className: "text-nowrap" }, "(&(uid={0})(objectClass=inetOrgPerson))"), ". The string", " ", /* @__PURE__ */ React.createElement("code", null, "{0}"), " will be replaced by the entered username."),
  userNameAttribute: /* @__PURE__ */ React.createElement("span", null, "Which LDAP attribute to use for the username of the synchronized user, e.g ", /* @__PURE__ */ React.createElement("code", null, "uid"), ".", /* @__PURE__ */ React.createElement("br", null), "Try to load a test user in the sidebar section ", /* @__PURE__ */ React.createElement("i", null, "User Login Test"), ", if you are unsure which attribute to use."),
  userFullNameAttribute: /* @__PURE__ */ React.createElement("span", null, "Which LDAP attribute to use for the full name of a synchronized user, e.g. ", /* @__PURE__ */ React.createElement("code", null, "cn"), ".", /* @__PURE__ */ React.createElement("br", null)),
  userUniqueIdAttribute: /* @__PURE__ */ React.createElement("span", null, "Which LDAP attribute to use for the ID of a synchronized user, e.g. ", /* @__PURE__ */ React.createElement("code", null, "entryUUID"), ".", /* @__PURE__ */ React.createElement("br", null)),
  defaultRoles: /* @__PURE__ */ React.createElement("span", null, "The default roles synchronized user will obtain. All users need the ", /* @__PURE__ */ React.createElement("code", null, "Reader"), " role, to use the web interface"),
  defaultUserTimezone: /* @__PURE__ */ React.createElement("span", null, "Choose the default time zone for new users."),
  emailAttributes: /* @__PURE__ */ React.createElement("span", null, "Which LDAP attribute to use for the user's email address, e.g. ", /* @__PURE__ */ React.createElement("code", null, "mail"), ".", /* @__PURE__ */ React.createElement("br", null), "You can specify multiple attributes, type ", /* @__PURE__ */ React.createElement("kbd", null, "Tab"), " or ", /* @__PURE__ */ React.createElement("kbd", null, "Enter"), " to accept your value.")
};
const INITIAL_VALUES = {
  title: AUTH_BACKEND_META.serviceTitle,
  serverHost: "localhost",
  serverPort: 636,
  transportSecurity: "tls",
  userFullNameAttribute: "cn",
  emailAttributes: ["mail", "rfc822Mailbox"],
  userNameAttribute: "uid",
  userUniqueIdAttribute: "entryUUID",
  verifyCertificates: true
};
const BackendCreate = () => {
  var _a, _b;
  const enterpriseGroupSyncPlugin = getEnterpriseGroupSyncPlugin();
  const { help: groupSyncHelp = {}, initialValues: initialGroupSyncValues = {} } = (_b = (_a = enterpriseGroupSyncPlugin == null ? void 0 : enterpriseGroupSyncPlugin.wizardConfig) == null ? void 0 : _a.ldap) != null ? _b : {};
  const help = { ...HELP, ...groupSyncHelp };
  const initialValues = { ...INITIAL_VALUES, ...initialGroupSyncValues };
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Create LDAP Authentication Service" }, /* @__PURE__ */ React.createElement(WizardPageHeader, null), /* @__PURE__ */ React.createElement(
    BackendWizard,
    {
      onSubmit: handleCreate,
      help,
      authBackendMeta: AUTH_BACKEND_META,
      initialValues
    }
  ));
};
export default BackendCreate;
